// Empty until the repository is actually published — while empty, every
// "View on GitHub" affordance hides itself rather than point at a dead URL.
export const GITHUB_REPO_URL: string = 'https://github.com/rdeanstickler-star/pulseresume';
